export function changeMinimumValue(data={}){

	const newValue = data.newValue;
	const type = data.type || "all";

	if(type == "textOnly" || type == "all"){

		$("."+this.minTextClass).html(newValue);

	};

	if(type == "valueOnly" || type == "all"){

		this.min = newValue;
		$("."+this.rangeInputClass).attr("min", newValue);
		
	};
	

};